import '../fake-db'
import React from 'react'
import axios from 'axios.js'
import { Provider } from 'react-redux'
import { Router, Switch, Route } from 'react-router-dom'
import AppContext from './contexts/AppContext'
import history from 'history.js'
import routes from './RootRoutes'
import { Store } from './redux/Store'
import { GlobalCss, MatxSuspense, MatxTheme, MatxLayout } from 'app/components'
import sessionRoutes from './views/sessions/SessionRoutes'
import AuthGuard from './auth/AuthGuard'
// import { AuthProvider } from 'app/contexts/FirebaseAuthContext'
// import { AuthProvider } from 'app/contexts/ServerAuthContext'
import { AuthProvider } from 'app/contexts/JWTAuthContext'
import { SettingsProvider } from 'app/contexts/SettingsContext'
import {SystemServerInfoProvider} from "./contexts/Reference/SystemServierInfo/ServerInfoContext";
import {QRBarcodeScannerProvider} from "./contexts/QrBarcodeContext/QrBarcodeContext";
import {AtolErrorTestProvider} from "./contexts/AtolErrorTest/AtolErrorTestContext"
import { TelephonyProvider } from './contexts/TelephonyContext';
import HiDPIBlocker from './components/HiDPIBlocker'
import FiscalProvider from './components/Fiscal/FiscalProvider'
// import 'flatpickr/dist/flatpickr.css'
import './styles/timepicker.css'
import './styles/flatpickr-theme.css'

const TariffsPublicPage = React.lazy(() => import('./views/pricing/TariffsPublicPage'))
const KnowledgePage = React.lazy(() => import('./views/knowledge/KnowledgePage'))

const App = () => {
    React.useEffect(() => {
        const runTimeDebug = async () => {
            try {
                const response = await axios.get('/api/profile/time-debug')
                const payload = response?.data || {}
                console.group('server-time-debug')
                console.log(payload)
                console.groupEnd()
                return payload
            } catch (e) {
                console.error('server-time-debug failed', e?.response?.data || e?.message || e)
                throw e
            }
        }

        window.debugServerTime = runTimeDebug
        window.getServerTimeDebug = runTimeDebug

        return () => {
            delete window.debugServerTime
            delete window.getServerTimeDebug
        }
    }, [])

    return (
        <AppContext.Provider value={{ routes }}>
            <Provider store={Store}>
                <SettingsProvider>
                    <MatxTheme>
                        <GlobalCss />
                        {/* Блокируем UI до Router, чтобы пользователь не успел увидеть «рваную» верстку */}
                        <HiDPIBlocker threshold={1.25} />
                        <Router history={history}>
                            <AuthProvider>
                                <MatxSuspense>
                                    <Switch>
                                        {/* AUTHENTICATION PAGES (SIGNIN, SIGNUP ETC.) */}
                                        {sessionRoutes.map((item, i) => (
                                            <Route
                                                key={i}
                                                path={item.path}
                                                component={item.component}
                                            />
                                        ))}
                                        {/* PUBLIC PAGES */}
                                        <Route path="/help" component={KnowledgePage} />
                                        <Route
                                            exact
                                            path="/others/tariffs"
                                            component={TariffsPublicPage}
                                        />
                                        {/* AUTH PROTECTED DASHBOARD PAGES */}
                                        <AuthGuard>
                                            <SystemServerInfoProvider>
                                                <AtolErrorTestProvider>
                                                    <QRBarcodeScannerProvider>
                                                        <TelephonyProvider>
                                                            <FiscalProvider><MatxLayout /></FiscalProvider>{' '}
                                                            {/* RETURNS <Layout1/> component */}
                                                        </TelephonyProvider>
                                                    </QRBarcodeScannerProvider>
                                                </AtolErrorTestProvider>
                                            </SystemServerInfoProvider>
                                        </AuthGuard>
                                    </Switch>
                                </MatxSuspense>
                            </AuthProvider>
                        </Router>
                    </MatxTheme>
                </SettingsProvider>
            </Provider>
        </AppContext.Provider>
    )
}

export default App
